<loader></loader>
<ng-container *ngIf="giantConfig.layout.style === 'admin-layout'">
    <admin-layout></admin-layout>
</ng-container>